import React, { useState, useEffect } from 'react';
import { View, Text } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import Button from '@components/button';

import { navigateBack, navigateTo, getSecureValue } from '@helpers';

export default ({ C, title, backgroundColor, logOnboarding }) => {
  const [isAuthorized, setIsAuthorized] = useState(false);
  useEffect(() => {
    (async () => {
      const auth = getSecureValue('token');
      setIsAuthorized(auth);
    })();
  }, []);

  return (
    <View style={{ width: '100%', flex: 1, alignItems: 'center', backgroundColor: backgroundColor || C('Background/Light/System') }}>
      <View
        style={{
          width: '100%',
          maxWidth: scale(360),
          paddingHorizontal: scale(29),
          flex: 1,
          paddingTop: scale(100),
          alignItems: 'center',
        }}
      >
        <View style={{ flex: 1 }}>
          <View style={{ alignItems: 'center' }}>
            <Svg icon="smartFactory" width={scale(140)} height={scale(70)} color={'Other/Light/Logo/Factory'} />
          </View>
        </View>
        <View style={{ flex: 1 }}>
          <View style={{ alignItems: 'center' }}>
            <Svg icon="ok" width={scale(44)} height={scale(44)} color={'System/Light/Green'} />
          </View>
          <Text style={[font.Headline, { color: C('Label/Light/Primary'), marginTop: scale(12), textAlign: 'center' }]}>
            {i18n.t(title || 'Connection Established')}
          </Text>
        </View>
        <View style={{ flex: 1, width: '100%', justifyContent: 'center' }}>
          <Button
            {...{
              name: i18n.t(isAuthorized ? 'Done' : `Next`),
              onPress: async () => {
                logOnboarding(
                  `Component: ${title || 'Connection Established'}. Action: ${isAuthorized ? 'Done' : `Next`}. User authorized: ${Boolean(
                    isAuthorized
                  )}`,
                  { component: title || 'Connection Established', action: isAuthorized ? 'Done' : `Next` }
                );
                if (isAuthorized) {
                  navigateTo('Settings', { screen: 'Connector' });
                } else {
                  navigateTo('EnterEmail', { scenario: 'onBoarding' });
                }
              },
              height: scale(53),
              width: '100%',
            }}
          />
        </View>
      </View>
    </View>
  );
};
